import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=e5626e98&scoped=true&"
import script from "./safety.vue?vue&type=script&lang=js&"
export * from "./safety.vue?vue&type=script&lang=js&"
import style0 from "./safety.vue?vue&type=style&index=0&id=e5626e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5626e98",
  null
  
)

export default component.exports